export enum EOwnerNotificationType {
  Blocked = 'user_blocked',
  Reported = 'reported',
  Refund = 'refund',
}
